import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Container,
    Menu,
    MenuItem,
    useMediaQuery,
    Box,
    Divider,
} from "@mui/material";


// Material UI ICONS
import MenuIcon from "@mui/icons-material/Menu";

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SaveIcon from '@mui/icons-material/Save';
import InvertColorsIcon from '@mui/icons-material/InvertColors';

import { styled } from '@mui/material/styles';

function MenuBar(params) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(null);
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMobileMenuToggle = (event) => {
        setMobileMenuOpen(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMenuOpen(null);
    };

    const renderDesktopMenu = () => (
        <Box sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>

            {params.setPassword}
            <div className="spacebox"></div>
            <IconButton color="ochre" onClick={params.handleClickOpen}>
                <CloudUploadIcon />
            </IconButton>
            <div className="spacebox"></div>
            <IconButton color="ochre" onClick={params.guardarDB}>
                <SaveIcon />
            </IconButton>

            <div className="spacebox"></div>
            <IconButton color="secondary" onClick={params.toggleModo}>
                <InvertColorsIcon />
            </IconButton>
        </Box>
    );

    const renderMobileMenu = () => (
        <Menu
            anchorEl={mobileMenuOpen}
            open={Boolean(mobileMenuOpen)}
            onClose={handleMobileMenuClose}
        >
            {params.setPassword}
            <Divider />
            <MenuItem onClick={params.guardarDB}>
                <IconButton color="ochre">
                    <SaveIcon />
                </IconButton>
                Guardar
            </MenuItem>
            <MenuItem onClick={params.handleClickOpen}>
                <IconButton color="ochre">
                    <CloudUploadIcon />
                </IconButton>
                Cargar
            </MenuItem>
            <Divider />
            <MenuItem onClick={params.toggleModo}>
                <IconButton color="secondary">
                    <InvertColorsIcon />
                </IconButton>
                Cambiar Color
            </MenuItem>            
        </Menu>
    );

    return (
        <React.Fragment>
            <AppBar position="fixed" color="ea">
                {/* <Container> */}
                    <Toolbar>
                        <Typography variant="h6" component="div">
                            Cotizador A House Interior
                        </Typography>
                        {isMobile ? (
                            <IconButton
                                edge="end"
                                color="inherit"
                                aria-label="menu"
                                onClick={handleMobileMenuToggle}
                                sx={{ marginLeft: "auto" }}
                            >
                                <MenuIcon />
                            </IconButton>
                        ) : (
                            renderDesktopMenu()
                        )}
                    </Toolbar>
                {/* </Container> */}
            </AppBar>
            {isMobile && renderMobileMenu()}
            <Toolbar />
        </React.Fragment>
    );
}

export default MenuBar;
